

<!-- Start of Quick search common component -->
  <app-quick-search 
    [DefaultFilterArray]="DefaultFilterArray"
    [QuickSearchFilterArray]="quickFilterArray"
    (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)">
  </app-quick-search>
<!-- End of Quick search common component -->

<!-- Filter Code -->
<div class="col-lg-12 nopadding">
  <app-filter-panel 
    pageName="CAIS-FDID"
    [GridColumns]="GridColumns" 
    [DefaultFilterArray]="DefaultFilterArray"
    (FilterEvent)="FilterApplyFilterEvent($event)"
    >
  </app-filter-panel>
</div>

<!-- Record Type Filter -->
<div class="col-lg-12 noLineHeight nopadding">
  <div class="ui-widget-header-1 nopadding">
    <ul class="nopadding">
      <label for="SUBMITTED">
        <p-button [id]="'SUBMITTED'" type="button" 
          [ngClass]="activeRecordType === 'MASTER' ? 'button btn-xs active-symbol cais-fdid-submission-button' : 'button btn-xs non-active-symbol'"
          (click)="getRecordTypeData('MASTER');this.activeRecordType = 'MASTER';">
          SUBMITTED
        </p-button>
      </label>
      <label for="NONSUBMITTED">
        <p-button [id]="'NONSUBMITTED'" type="button" 
          [ngClass]="activeRecordType === 'STAGING' ? 'button btn-xs active-symbol cais-fdid-submission-button' : 'button btn-xs non-active-symbol'"
          (click)="getRecordTypeData('STAGING');this.activeRecordType = 'STAGING';">
          NOT SUBMITTED
        </p-button>
      </label>
    </ul>
  </div>
</div>

<!-- Add Button -->
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
    <div class="ui-grid-col-12 btnPanel">
      <label for="addBtn">
        <button pButton id="addBtn" type="button" [disabled]="false" label="Add Account" (click)="onRowSelect('Add');" class="button add-button btn-lg cais-fdid-add-account-label"></button>
      </label>
    </div>
  </div>
</div>

<!-- Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }
  <p-table 
    id="FDIDListingTable"
    alwaysShowPaginator="true" 
    paginatorPosition="both" 
    showCurrentPageReport="true"
    [value]="dataset" 
    [columns]="cols" 
    [resizableColumns]="true" 
    columnResizeMode="expand"
    [totalRecords]="totalRecords" 
    [(selection)]="this.dataService.roeSelectedRecords"
    [paginator]="true"
    selectionMode="single"
    appendTo="body"
    (onPage)="changePage($event)"
    (onSort)="sort($event)" 
    sortMode="multiple"
    [rows]="constantService.DEFAULT_ROWSIZE" 
    [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS"
    [rowsPerPageOptions]="rowsPerPageOptions"  
    [lazy]="true" 
    [scrollable]="true" 
    scrollHeight="60vh"
    styleClass="tableData"
    #dt>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length" class="text-center">
          {{tbldatamsg}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
          @if(!col?.isoptionalfields){
            <th id="colHeader" pResizableColumn [pSortableColumn]="col.field"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
              {{col.header}}
              @if((col.header | lowercase) !== 'action'){
              <p-sortIcon [field]="col.field"></p-sortIcon>
              }
            </th>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex"
        [ngClass]="(row['active'] | lowercase) == 'n' || row['fdidEndDate'] != '' ? 'ui-widget-deleted-row' : 'ui-widget-NoUpdated-row'">
        @for(col of columns; track col.field + '-'+ $index) {
          @if(!col?.isoptionalfields){
            <td class="ui-resizable-column"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : '' ">
              <!-- set String -->
              @if(!['Action', 'Year Of Birth', 'Finra Status'].includes(col.header)){
              <span>
                  {{row[col.field]}}
              </span>
              }
              @if(['Year Of Birth'].includes(col.header)){
              <span>
                {{row[col.field].substr(0, row[col.field].length-2) + '*'.repeat(2)}}
              </span>
              }
              @if(['Finra Status'].includes(col.header)){
              <span [ngClass]="(row[col.field] | lowercase)== 'rejected' ? 'ui-widget-rejected-Font':''">
                {{row[col.field]}}
              </span>
              }
              @if(col.header === 'Action'){
              <span>
                <p-button [id]="'ViewBtn'+row['id']" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" matTooltipPosition="above"
                  appendTo="body" icon="fa fa-xxx fa-eye" (click)="onRowSelect('View',rowIndex,row);"></p-button>
                <p-button [id]="'EditBtn'+row['id']" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Edit" matTooltipPosition="above"
                  appendTo="body" icon="fa fa-xxx fa-edit" (click)="onRowSelect('Edit',rowIndex,row);"></p-button>
                <p-button [id]="'AuditBtn'+row['id']" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Audit-Trail" matTooltipPosition="above"
                  appendTo="body" icon="fa fa-fw fa-list" (click)="onRowSelect('AuditTrail',rowIndex,row)"></p-button>
                  <p-button class="pi pi-xxx" class="fa fa-xxx iconBtn" matTooltip="Clone"  matTooltipPosition="above"
                    appendTo="body" icon="fa fa-fw fa-copy" (click)="copyDetails(row,rowIndex)"></p-button>
              </span>
              }
            </td>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <app-export-to-csv [gridColumns]="CAISFDIDCSVGridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
      Total Records: {{dataset.length == 0? 0 : totalRecords}}
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <!-- Page No : {{pageNumber }} -->
      Showing {{dataset.length == 0? 0 : startLimit + 1}} to {{dataset.length
          < rowcount ? dataset.length < startLimit ? endLimit : dataset.length : endLimit}} entries
    </ng-template>
  </p-table>
  <br>
  <br>
</div>

<!-- Add Panel Code -->
  <p-dialog id="AddDialog" [(visible)]="Add" appendTo="body" height="auto" width="auto" (onHide)="isClickedOnce=false;closeDialog(false);"
  [style]="{width: '78%', minWidth: '550px'}" [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
    maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [focusOnShow]="false" [modal]="false" draggable="true"
    styleClass= "cais-fdid-form-dialog">
    <ng-template #header class = "dialog-header"><span [ngClass]="isCopyRecord ? 'duplicateHeaderClass' : ''">{{isCopyRecord ? 'Clone CAIS-FDID' : 'Add CAIS-FDID'}}</span></ng-template>
    <div styleClass="col-lg-12 nopadding">
      @if(isAddLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
      }
      <mat-list-item class="list-item-title">FDID Details</mat-list-item>
      <mat-divider></mat-divider>

      <!-- Record Details -->
       @if(Add){
        <div class="ui-grid-col-12 container">
          <!-- Medium Scaled Field -->
          @for(viewRow of screenDataDetails; track viewRow.ui_Field_Name + '-'+ $index) {
            @if(!viewRow.isOptionalFields){
              <span [ngClass]="(addScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || ExceptionalFDIDScreenFields.includes(viewRow.ui_Field_Name) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
                <span>
                  <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                    <div [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                      @if(viewRow.isrequired){
                      <strong class="error-mark">*</strong>
                      }
                    </div>
                    <div [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <span>
                        @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                        <ng-container>
                          <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]" [disabled]="viewRow.isDisable || ([viewRow.field_Name].includes('DVPCustodianID') && !FDIDScreenDataDetails['accountType']) || ([viewRow.field_Name].includes('DVPCustodianID') && FDIDScreenDataDetails['accountType'] && !FDIDScreenDataDetails['accountType'].includes('DVP/RVP'))" 
                          [maxlength]="viewRow.maximumLength" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off" 
                          [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorField' : ''" 
                          (ngModelChange)="FDIDScreenDataDetails[viewRow.field_Name] = (['accountNumber', 'accountName'].includes(viewRow.field_Name) ? $event.toUpperCase() : FDIDScreenDataDetails[viewRow.field_Name]);" />
                          <div [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</div>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'date'){
                        <ng-container>
                          <p-datepicker inputId="dpm" [touchUI]="true" appendTo="body"   [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]" dateFormat="yy-mm-dd" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                            [disabled]="viewRow.isDisable" [readonlyInput]="false" [maxDate]="FutureRestrictedFields.includes(viewRow.ui_Field_Name) ? maximumDateTime : ''" 
                            [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                            styleClass="calendar-form-field" [motionOptions]="{ duration: 0 }">
                          </p-datepicker>
                          <span [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                        <ng-container>
                          <p-select styleClass ="cais-fdid-form-dropdown" appendTo="body" [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'" 
                            [options]="viewRow.dropdownvalue" [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]" [disabled]="viewRow.isDisable" [showClear]="true" 
                            [placeholder]="'Enter Value'" class="maxChoiceWidth" [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                          </p-select>
                          <span [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                        <ng-container>
                          <p-multiSelect id = "caisAccountTypeMultiselect" appendTo="body" [name]="viewRow.field_Name +'array'" [id]="viewRow.field_Name+'array'" 
                            [options]="viewRow.dropdownvalue" [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]" [disabled]="viewRow.isDisable" 
                            [placeholder]="'Please select choices'" class="maxMultiChoiceWidth cais-fdid-multiselect-dropdown cais-fdid-multiselect" [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                          </p-multiSelect>
                          <span [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                        </ng-container>
                        }
                      </span>
                    </div>
                  </div>
                </span>
              </span>
            }
          }
          <!-- End of Medium Scaled Field -->
        </div>
        }
      <!-- End of Record Details -->
     
      <mat-divider></mat-divider>

      <!-- LTID Details -->
      @if(caisServiceService.hasAnyActiveField(LTIDGridColumns)) {
      <mat-list-item class="list-item-title">LTID Details</mat-list-item>
        <div class="ui-grid-col-12 container">
          <p-table id="AddLTIDTable" [columns]="LTIDGridColumns" [value]="LTIDDataSet" class="LTIDDTTable">
            <ng-template pTemplate="header" let-columns let-rowIndex=rowIndex>
              <tr>
                <th id="tableHeader"></th>
                @for(col of columns; track col.field + '-'+ $index) {
                <th id="ui_columnname" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                  {{col.ui_columnname}}
                </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
              <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
                @if((LTIDDataSet.length === (rowIndex+1))){
                <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="LTIDDataSet.push({largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: ''});"><em class="pi pi-plus"></em></a></td>
                }
                @if((LTIDDataSet.length !== (rowIndex+1))){
                <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="removeLTID(rowIndex)"><em class="pi pi-minus"></em></a></td>
                }
                @for(col of columns; track col.field + '-'+ $index) {
                <td pEditableColumn class="ui-resizable-column" [ngClass]="{'notdisplay':((col?.display | lowercase) == 'false'), 'errorFieldBorderBottom':(row['errorFields'] && row['errorFields'][col.mappingkey])}">
                  <p-cellEditor>
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no'){
                    <ng-template pTemplate="input">
                      <input pInputText type="text" [id]="row[col.mappingkey]+'string'" [(ngModel)]="row[col.mappingkey]" [placeholder]="(col.placeholder ? col.placeholder : '')"
                      [title]="(col.placeholder ? col.placeholder : '')" [disabled]="col.disabled">
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'date'){
                    <ng-template pTemplate="input">
                      <p-datepicker inputId="dplt" [touchUI]="true" appendTo="body" [(ngModel)]="row[col.mappingkey]" dateFormat="yy-mm-dd" [placeholder]="(col.placeholder ? col.placeholder : '')" 
                        [disabled]="col.disabled" [readonlyInput]="false"
                        styleClass="calendar-form-field" [motionOptions]="{ duration: 0 }">
                      </p-datepicker>
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){
                    <ng-template pTemplate="input">
                      <p-select styleClass ="cais-fdid-form-dropdown" appendTo="body" [name]="row[col.mappingkey]+'singleselect'" [id]="row[col.mappingkey]+'singleselect'" 
                        [options]="col.dropdownvalue" [(ngModel)]="row[col.mappingkey]" [disabled]="col.disabled" [showClear]="true" 
                        [placeholder]="'Enter Value'" class="maxChoiceWidth">
                      </p-select>
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no'){
                    <ng-template pTemplate="output">
                      {{row[col.mappingkey]}}
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'date'){
                    <ng-template pTemplate="output">
                      {{getFormat(row[col.mappingkey])}}
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){
                    <ng-template pTemplate="output">
                      {{row[col.mappingkey]}}
                    </ng-template>
                    }
                  </p-cellEditor>
                </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      <!-- End of LTID Details -->
      <!-- Address Details -->
      <mat-divider></mat-divider>
      @if(caisServiceService.hasAnyActiveField(addressColumns)) {
      <mat-list-item class="list-item-title">Address Details</mat-list-item>
        <div class="ui-grid-col-12 container">
          <p-table id="AddFDIDAddressTable" [columns]="addressColumns" 
          [value]="FDIDAddressDetails" class="AddressTable" [resizableColumns]="true" #add_dt>
            <ng-template pTemplate="colgroup" let-columns>
              <colgroup>
                  @for(col of columns; track col.field + '-'+ $index) {
                  <col>
                  }
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns let-ri=rowIndex>
              <tr>
                <th id="header"></th>
                @for(col of columns; track col.field + '-'+ $index) {
                <th id="colHeader">
                  {{col.header}}
                </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-columns="columns" let-addressRowData let-rowIndex="rowIndex">
              <tr [pSelectableRow]="addressRowData" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
                @if((FDIDAddressDetails.length === (rowIndex+1))){
                  <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="FDIDAddressDetails.push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em class="pi pi-plus"></em></a></td>
                  }
                  @if((FDIDAddressDetails.length !== (rowIndex+1))){
                  <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="FDIDAddressDetails.splice(rowIndex,1);"><em class="pi pi-minus"></em></a></td>
                  }
                @for(col of columns; track col.field + '-'+ $index) {
                <td pEditableColumn class="ui-resizable-column"
                  [ngClass]="{'errorFieldBorderBottom':(addressRowData['errorFields'] && addressRowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                  @if(!['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input pInputText type="text" [id]="addressRowData[col.field]+'string'" [maxlength]="col.maxlength" 
                        [disabled]="col.disabled" [(ngModel)]="addressRowData[col.field]">
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{addressRowData[col.field]}}
                    </ng-template>
                  </p-cellEditor>
                  }
                  <!-- Country & Region Code Menu List -->
                  @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                  <p-select styleClass ="cais-fdid-form-dropdown justify-center table-column-dropdown"
                    [id]="addressRowData[col.field]+'singleselect'" appendTo="body" [options]="col.dropdownvalue"
                    [(ngModel)]="addressRowData[col.field]" [showClear]="true" [filter]="true" [placeholder]="addressRowData[col.field] == '' ? 'Enter Value' : addressRowData[col.field]"
                    [disabled]="col.disabled" class="maxChoiceWidth"
                    (ngModelChange)="addressRowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && addressRowData['addr_regionCode'] && (!addressRowData['addr_countryCode'] || ['US', 'CA'].includes(addressRowData['addr_countryCode']))) ? addressRowData['addr_regionCode'].slice(0,2) : addressRowData['addr_countryCode'])">
                  </p-select>
                  }
                </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      <!-- End of Address Details -->
      <mat-divider></mat-divider>
      <mat-list-item class="list-item-title">Natural Person/Legal Entity List Details</mat-list-item>

      <!-- TID Generator Button -->
        <div class="ui-grid-col-12 container text-right nopadding">
          <div class="col-lg-12">
            <label class="nopadding" for="addCustomerSearchDialogBtn">
              <button pButton id="addCustomerSearchDialogBtn" type="button" [disabled]="false" class="button customer-search-button btn-lg" title="Search Customer" (click)="caisServiceService.isDisplayCustomerSearchList = true;" icon="pi pi-search"></button>
            </label>
            <label class="nopadding" for="TIDGeneratorDialogBtn">
              <button pButton id="TIDGeneratorDialogBtn" type="button" [disabled]="false" label="TID Generator" (click)="openTIDGenrator()" class="button form-action-button btn-lg form-action-button-label"></button>
            </label>
            <label class="nopadding" for="AddNaturalPersonTabBtn">
              <button pButton id="AddNaturalPersonTabBtn" type="button" [disabled]="false" label="Add Natural Person" (click)="addNewTab('Natural Person');" class="button form-action-button btn-lg form-action-button-label"></button>
            </label>
            <label class="nopadding" for="AddLegalEntityTabBtn">
              <button pButton id="AddLegalEntityTabBtn" type="button" [disabled]="false" label="Add Legal Entity" (click)="addNewTab('Legal Entity');" class="button form-action-button btn-lg form-action-button-label"></button>
            </label>
          </div>
        </div>
      <!-- End of TID Generator Button -->
      <!-- Natural Person/Legal Entity List -->
      <div class="ui-grid-col-12 container card tabView-container">
        <p-tabs class="cais-fdid-tab" [id]="'addNaturalPersonLegalEntityTab'" [value]="selectedTabIndex" (valueChange)="handleChange($event)" scrollable>
        <p-tablist>
          @for(NaturalPerson of NaturalPersons; track NaturalPerson.tabIndex + '-'+ $index; let i = $index) {
            <p-tab [value]="NaturalPerson.tabIndex">
              {{NaturalPerson.name}}
              </p-tab>
          }
          @for(LegalEntity of LegalEntities; track LegalEntity.tabIndex + '-'+ $index; let i = $index) {
            <p-tab [value]="LegalEntity.tabIndex">
              {{LegalEntity.name}}
              </p-tab>
          }
          </p-tablist>
          <p-tabpanels>
            @for(NaturalPerson of NaturalPersons; track NaturalPerson.tabIndex + '-'+ $index; let i = $index) {
              <ng-container>
              <p-tabpanel [value]="NaturalPerson.tabIndex">
                @if(Add && NaturalPersonDataDetails.length > 0){
              <div class="ui-grid-col-12 container contents">
                <!-- Natural Person Fields -->
                @for(viewRow of NaturalPersonScreenDataDetails; track viewRow.ui_Field_Name + '-'+ $index) {
                  @if(!viewRow.isOptionalFields){
                    <!-- Generate Encrypted TID Value -->
                      @if(viewRow.ui_Field_Name==='TID Value'){
                        <app-tid-generator [GeneratorType]="'formTIDGenerator'" [UserType]="'NaturalPerson'" [TIDType]="NaturalPersonDataDetails[i].tidType" [foreignTIDType]="NaturalPersonDataDetails[i].foreignTIDType" (receiveTIDValue)="applyTIDValue('NaturalPerson', i);"></app-tid-generator>
                      }
                    <!-- End of Generating Encrypted TID Value -->
                    <span [ngClass]="((addScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || CommonNegotiatedFields.includes(viewRow.ui_Field_Name)) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
                      <span>
                        <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                          <div [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                            <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                            @if(viewRow.isrequired){
                            <strong class="error-mark">*</strong>
                            }
                          </div>
                          <div [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                            @if(!yearField.includes(viewRow.ui_Field_Name)){
                            <span>
                              @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                              <ng-container>
                                <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]" [disabled]="viewRow.isDisable"  
                                [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off" [maxlength]="viewRow.maximumLength" 
                                [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorField' : ''" />
                                <span [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </ng-container>
                              }
                              @if((viewRow?.datatype | lowercase) === 'date'){
                              <ng-container>
                                <p-datepicker inputId="dpnp" [touchUI]="true" [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]" dateFormat="yy-mm-dd" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                                  appendTo="body" [disabled]="viewRow.isDisable" [readonlyInput]="false" [maxDate]="FutureRestrictedFields.includes(viewRow.ui_Field_Name) ? maximumDateTime : ''" 
                                  [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                                  styleClass="calendar-form-field" [motionOptions]="{ duration: 0 }">
                                </p-datepicker>
                                <span [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </ng-container>
                              }
                              @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                              <ng-container>
                                <p-select styleClass ="cais-fdid-form-dropdown" appendTo="body" [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'" 
                                  [options]="viewRow.dropdownvalue" [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]" [showClear]="true" [disabled]="caisServiceService.isDisabled(viewRow, NaturalPersonDataDetails[i])" (onChange)="caisServiceService.onChangeSelectionBox(viewRow, NaturalPersonDataDetails[i])" 
                                  [placeholder]="'Enter Value'" class="maxChoiceWidth" [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                                </p-select>
                                <span [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </ng-container>
                              }
                              @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                              <ng-container>
                                <p-multiSelect id ="npCustTypeMultiselect" appendTo="body" [name]="viewRow.field_Name +'array'" [id]="viewRow.field_Name+'array'" 
                                  [options]="viewRow.dropdownvalue" [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]" [disabled]="viewRow.isDisable" 
                                  [placeholder]="'Please select choices'" class="maxMultiChoiceWidth cais-fdid-multiselect-dropdown cais-fdid-multiselect" [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                                </p-multiSelect>
                                <span [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </ng-container>
                            }
                            </span>
                            }
                            @if(yearField.includes(viewRow.ui_Field_Name)){
                            <span>
                              <input pInputText inputId="birthYear" class="birthYear" [id]="viewRow.field_Name+i" [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]" [disabled]="viewRow.isDisable" autocomplete="off" 
                                  [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [maxlength]="viewRow.maximumLength" [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorField' : ''" 
                                  (keyup)="maskYear()" (focus)="unMaskYear(viewRow.value)" (focusout)="maskYear()" />
                              <span [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                            </span>
                            }
                          </div>
                        </div>
                      </span>
                    </span>
                    <!-- Instructions for TID Value Generation -->
                      @if(viewRow.ui_Field_Name==='TID Value'){
                        <app-tid-generator [GeneratorType]="'TIDGeneratorInstructions'"></app-tid-generator>
                      }
                    <!-- End of Instructions for TID Value Generation -->
                  }
                }
                <!-- End of Natural Person Fields -->
              </div>
              }
              <!-- Add Natural Person Address Details -->
              @if(caisServiceService.hasAnyActiveField(addressColumnsAction)) {
                <div class="ui-grid-col-12 container contents">
                  <p-table id="AddNaturalPersonAddressTable" [columns]="addressColumnsAction" 
                  [value]="NaturalPersonAddressDetails[i]"
                   class="AddressTable form-table" [resizableColumns]="true" #add_dt>
                    <ng-template pTemplate="colgroup" let-columns>
                      <colgroup>
                        @for(col of columns; track col.field + '-'+ $index) {
                          <col>
                        }
                      </colgroup>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        <th id="header"></th>
                        <th id="Action">Action</th>
                        @for(col of columns; track col.header + '-'+ $index) {
                        <th id="colHeader">
                          {{col.header}}
                        </th>
                        }
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
                      <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri">
                        @if((NaturalPersonAddressDetails[i].length === (ri+1))){
                          <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="NaturalPersonAddressDetails[i].push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em class="pi pi-plus"></em></a></td>
                          }
                          @if((NaturalPersonAddressDetails[i].length !== (ri+1))){
                          <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="NaturalPersonAddressDetails[i].splice(ri,1);"><em class="pi pi-minus"></em></a></td>
                          }
                        <td>
                          @if(!Edit && !View){
                          <span>
                            <p-button class="pi pi-xxx" class="fa fa-xxx iconBtn" 
                            matTooltip="Copy Address" id="{{ri}}"
                            matTooltipPosition="above"
                             appendTo="body" icon="fa fa-fw fa-copy" 
                             (click)="copyAddress(FDIDAddressDetails[ri],ri,true,i)"></p-button>                            
                          </span>
                          }
                        </td>
                        @for(col of columns; track col.field + '-'+ $index) {
                        <td pEditableColumn [ngClass]="{'errorFieldBorderBottom':(rowData['errorFields'] && rowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                          
                          @if(!['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                            <span>
                              <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [id]="rowData[col.field]+'string'" [(ngModel)]="rowData[col.field]" [maxlength]="col.maxlength" [disabled]="col.disabled">
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{rowData[col.field]}}
                                </ng-template>
                              </p-cellEditor>
                            </span>
                          }
                          <!-- Country & Region Code Menu List -->
                          @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                          <p-select styleClass ="cais-fdid-form-dropdown justify-center table-column-dropdown" [id]="rowData[col.field]+'singleselect'"
                            appendTo="body" [options]="col.dropdownvalue" [(ngModel)]="rowData[col.field]" [showClear]="true" [filter]="true" [disabled]="col.disabled" 
                            [placeholder]="'Enter Value'" class="maxChoiceWidth" (ngModelChange)="rowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && rowData['addr_regionCode'] && (!rowData['addr_countryCode'] || ['US', 'CA'].includes(rowData['addr_countryCode']))) ? rowData['addr_regionCode'].slice(0,2) : rowData['addr_countryCode'])">
                          </p-select>
                          }
                        </td>
                        }
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              }
              <!-- End of Add Natural Person Address Details -->
              <!-- Add/Save Natural Person -->
                <div class="ui-dialog-buttonpane ui-helper-clearfix pull-right">
                  <p-button type="button" icon="fa fa-close" id="ResetNaturalPerson" (click)="resetNaturalPerson(i);" class="cais-fdid-footer-button" label="Reset"></p-button>
                  <p-button type="button" icon="fa fa-check" id="SaveNaturalPerson" (click)="saveNaturalPerson(i);" class="cais-fdid-footer-button" label="Save Natural Person"></p-button>
                  <p-button type="button" icon="fa fa-trash" id="RemoveNaturalPerson" (click)="removeNaturalPerson(i);" class="cais-fdid-footer-button" label="Remove" [disabled]="(NaturalPerson.id===0)"></p-button>
                </div>
              <!-- End of Add/Save Natural Person -->
                </p-tabpanel>
              </ng-container>
            }
           @for(LegalEntity of LegalEntities; track LegalEntity.tabIndex + '-'+ $index; let i = $index) {
              <ng-container>
              <p-tabpanel [value]="LegalEntity.tabIndex">
                @if(Add && LegalEntityDataDetails.length > 0){
              <div class="ui-grid-col-12 container contents">
                <!-- Legal Entity Fields -->
                @for(viewRow of LegalEntityScreenDataDetails; track viewRow.ui_Field_Name + '-'+ $index) {
                  @if(!viewRow.isOptionalFields){
                    <!-- Generate Encrypted TID Value -->
                      @if(viewRow.ui_Field_Name==='TID Value'){
                        <app-tid-generator [GeneratorType]="'formTIDGenerator'" [UserType]="'LegalEntity'" [TIDType]="LegalEntityDataDetails[i].tidType" [foreignTIDType]="LegalEntityDataDetails[i].foreignTIDType" (receiveTIDValue)="applyTIDValue('LegalEntity', i);"></app-tid-generator>
                      }
                    <!-- End of Generating Encrypted TID Value -->
                    <span [ngClass]="((addScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || CommonNegotiatedFields.includes(viewRow.ui_Field_Name)) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
                      <span>
                        <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                        <div [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 
                        ['Add Legal Entity'].includes(LegalEntity.name) && viewRow.field_Name === 'legalName' ? 'ui-g-12 ui-md-5 ui-lg-5 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                            <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                            @if(viewRow.isrequired){
                            <strong class="error-mark">*</strong>
                            }
                          </div>
                          @if(['Add Legal Entity'].includes(LegalEntity.name) && viewRow.field_Name === "legalName"){
                            <div [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
                              <p-button class="pi pi-xxx" class="fa fa-xxx iconBtn" 
                              matTooltip="Populate Legal Name" id="legalNameCopy + i"
                              matTooltipPosition="above"
                              appendTo="body" icon="fa fa-fw fa-copy" 
                              (click)="populateLegalName()"></p-button>   
                            </div>
                            }
                          <div [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                            @if(!yearField.includes(viewRow.ui_Field_Name)){
                            <span>
                              @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                              <ng-container>
                                <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]" [disabled]="viewRow.isDisable" 
                                [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off" 
                                [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorField' : ''" 
                                (keyup)="setTIDType(viewRow.field_Name, i);" (ngModelChange)="AutoGenerateTID($event, viewRow.field_Name, i)" />
                                <span [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </ng-container>
                              }
                              @if((viewRow?.datatype | lowercase) === 'date'){
                              <ng-container>
                                <p-datepicker inputId="dple" [touchUI]="true" [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]" dateFormat="yy-mm-dd" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                                  appendTo="body" [disabled]="viewRow.isDisable" [readonlyInput]="false" [maxDate]="FutureRestrictedFields.includes(viewRow.ui_Field_Name) ? maximumDateTime : ''" 
                                  [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                                  styleClass="calendar-form-field" [motionOptions]="{ duration: 0 }">
                                </p-datepicker>
                                <span [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </ng-container>
                              }
                              @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                              <ng-container>
                                <p-select styleClass ="cais-fdid-form-dropdown" appendTo="body" [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'" 
                                  [options]="viewRow.dropdownvalue" [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]" [showClear]="true" [disabled]="caisServiceService.isDisabled(viewRow, LegalEntityDataDetails[i])" (onChange)="caisServiceService.onChangeSelectionBox(viewRow, LegalEntityDataDetails[i])" 
                                  [placeholder]="'Enter Value'" class="maxChoiceWidth" [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''"
                                  (ngModelChange)="AutoGenerateTID($event, viewRow.field_Name, i)">
                                </p-select>
                                <span [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </ng-container>
                              }
                              @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                              <ng-container>
                                <p-multiSelect id ="lgCustTypeMultiselect" appendTo="body" [name]="viewRow.field_Name +'array'" [id]="viewRow.field_Name+'array'" 
                                  [options]="viewRow.dropdownvalue" [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]" [disabled]="viewRow.isDisable" 
                                  [placeholder]="'Please select choices'" class="maxMultiChoiceWidth cais-fdid-multiselect-dropdown cais-fdid-multiselect" [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                                </p-multiSelect>
                                <span [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </ng-container>
                              }
                            </span>
                            }
                          </div>
                        </div>
                      </span>
                    </span>
                    <!-- Instructions for TID Value Generation -->
                      @if(viewRow.ui_Field_Name==='TID Value'){
                        <app-tid-generator [GeneratorType]="'TIDGeneratorInstructions'"></app-tid-generator>
                      }
                    <!-- End of Instructions for TID Value Generation -->
                  }
                }
                <!-- End of Legal Entity Fields -->
              </div>
              }
              <!-- Add Legal Entity Address Details -->
              @if(caisServiceService.hasAnyActiveField(addressColumnsAction)) {
                <div class="ui-grid-col-12 container contents">
                  <p-table id="AddLegalEntityAddressTable" [columns]="addressColumnsAction" 
                  [value]="LegalEntityAddressDetails[i]" class="AddressTable form-table" 
                  [resizableColumns]="true" #add_dt>
                    <ng-template pTemplate="colgroup" let-columns>
                      <colgroup>
                          @for(col of columns; track col.field + '-'+ $index) {
                          <col>
                          }
                      </colgroup>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        <th id="header"></th>
                        <th id="Action">Action</th>
                        @for(col of columns; track col.header + '-'+ $index) {
                        <th id="colHeader">
                          {{col.header}}
                        </th>
                        }
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
                      <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri">
                        @if((LegalEntityAddressDetails[i].length === (ri+1))){
                          <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="LegalEntityAddressDetails[i].push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em class="pi pi-plus"></em></a></td>
                          }
                          @if((LegalEntityAddressDetails[i].length !== (ri+1))){
                          <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="LegalEntityAddressDetails[i].splice(ri,1);"><em class="pi pi-minus"></em></a></td>
                          }
                        <td>
                          @if(!Edit && !View){
                          <span>
                            <p-button class="pi pi-xxx" class="fa fa-xxx iconBtn" 
                            matTooltip="Copy Address" id="{{ri}}"
                            matTooltipPosition="above"
                             appendTo="body" icon="fa fa-fw fa-copy" 
                             (click)="copyAddress(FDIDAddressDetails[ri],ri,false,i)"></p-button>                            
                          </span>  
                          }
                        </td>
                        @for(col of columns; track col.header + '-'+ $index) {
                        <td pEditableColumn [ngClass]="{'errorFieldBorderBottom':(rowData['errorFields'] && rowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                                               
                          @if(!['Action','addr_regionCode', 'addr_countryCode'].includes(col.field)){
                            <p-cellEditor>
                              <ng-template pTemplate="input">
                                  <input pInputText type="text" [id]="rowData[col.field]+'string'" [(ngModel)]="rowData[col.field]" [maxlength]="col.maxlength" [disabled]="col.disabled">
                              </ng-template>
                              <ng-template pTemplate="output">
                                  {{rowData[col.field]}}
                              </ng-template>
                            </p-cellEditor>
                          }
                          <!-- Country & Region Code Menu List -->
                           @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                          <p-select styleClass ="cais-fdid-form-dropdown justify-center table-column-dropdown"  [id]="rowData[col.field]+'singleselect'"
                            appendTo="body" [options]="col.dropdownvalue" [(ngModel)]="rowData[col.field]" [showClear]="true" [filter]="true" [disabled]="col.disabled" 
                            [placeholder]="'Enter Value'" class="maxChoiceWidth" (ngModelChange)="rowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && rowData['addr_regionCode'] && (!rowData['addr_countryCode'] || ['US', 'CA'].includes(rowData['addr_countryCode']))) ? rowData['addr_regionCode'].slice(0,2) : rowData['addr_countryCode'])">
                          </p-select>
                          }
                        </td>
                        }
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              }
              <!-- End of Add Legal Entity Address Details -->
              <!-- Add/Save Legal Entity -->
                <div class="ui-dialog-buttonpane ui-helper-clearfix pull-right">
                  <p-button type="button" icon="fa fa-close" id="ResetLegalEntity" (click)="resetLegalEntity(i);" class="cais-fdid-footer-button" label="Reset"></p-button>
                  <p-button type="button" icon="fa fa-check" id="SaveLegalEntity" (click)="saveLegalEntity(i);" class="cais-fdid-footer-button" label="Save Legal Entity"></p-button>
                  <p-button type="button" icon="fa fa-trash" id="RemoveLegalEntity" (click)="removeLegalEntity(i);" class=" cais-fdid-footer-button" label="Remove" [disabled]="(LegalEntity.id===0)"></p-button>
                </div>
              <!-- End of Add/Save Legal Entity -->
                </p-tabpanel>
              </ng-container>
            }
            </p-tabpanels>
        </p-tabs>
      </div>
      <!-- End of Natural Person/Legal Entity List -->
    </div>
    <ng-template #footer>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <p-button type="button" class="cais-fdid-footer-button" icon="fa fa-close" id="CloseAddDialog" (click)="Add=false;isClickedOnce=false;closeDialog(false);" label="Close">
        </p-button>
        <p-button type="button" class="cais-fdid-footer-button" icon="fa fa-check" id="addSaveDialog" (click)="addFDIDRecord()" [disabled]="isClickedOnce" label="Save">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
<!-- End of Adding Panel Code -->

<!-- Edit Panel Code -->
  <p-dialog id="EditDialog" [(visible)]="Edit" appendTo="body" height="auto" width="auto" (onHide)="isClickedOnce=false;closeDialog(false);"
  [style]="{width: '78%', minWidth: '550px'}" [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
    maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [focusOnShow]="false" [modal]="false" draggable="true"
    styleClass= "cais-fdid-form-dialog">
    <ng-template #header class = "dialog-header">Edit {{screenType}}</ng-template>
    <div class="col-lg-12 nopadding">
      @if(isEditLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
      }
      <mat-list-item class="list-item-title">FDID Details</mat-list-item>
      <mat-divider></mat-divider>

      <!-- Record Details -->
       @if(Edit){
        <div class="ui-grid-col-12 container">
          <!-- Medium Scaled Field -->
          @for(viewRow of screenDataDetails; track viewRow.ui_Field_Name + '-'+ $index) {
            @if(!viewRow.isOptionalFields){
              <span [ngClass]="(editScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || ExceptionalFDIDScreenFields.includes(viewRow.ui_Field_Name) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
                <span>
                  <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                    <div [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                      @if(viewRow.isrequired){
                      <strong class="error-mark">*</strong>
                      }
                    </div>
                    <!-- Switch for preserving Important Field value -->
                    @if(editDisabledFields.includes(viewRow.ui_Field_Name)){
                      <div [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
                        <span>
                          <ng-container>
                            <p-toggleswitch [(ngModel)]="isClickOnFDIDCorrection" (click)="changeReceivedFDID(viewRow)"></p-toggleswitch>
                          </ng-container>
                        </span>
                      </div>
                      }
                    <!-- End of Switch for preserving Important Field value -->
                    <div [ngClass]="(viewRow.isLargeField ? (editDisabledFields.includes(viewRow.ui_Field_Name) ? 'ui-g-12 ui-md-7 ui-lg-7 quick-view-grid-row-hg' : 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg') : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <span>
                        @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                        <ng-container>
                          <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]" [disabled]="viewRow.isDisable || ([viewRow.field_Name].includes('DVPCustodianID') && FDIDScreenDataDetails['accountType'] && !FDIDScreenDataDetails['accountType'].includes('DVP/RVP'))" [maxlength]="viewRow.maximumLength" 
                            [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off" 
                            [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorField' : ''" 
                            (ngModelChange)="FDIDScreenDataDetails[viewRow.field_Name] = (['accountNumber', 'accountName'].includes(viewRow.field_Name) ? $event.toUpperCase() : FDIDScreenDataDetails[viewRow.field_Name]); " />
                            <span [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'date'){
                        <ng-container>
                          <p-datepicker inputId="dpm" [touchUI]="true" [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]" dateFormat="yy-mm-dd" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                            showButtonBar="true" appendTo="body" [disabled]="viewRow.isDisable" [readonlyInput]="false" [maxDate]="FutureRestrictedFields.includes(viewRow.ui_Field_Name) ? maximumDateTime : ''" 
                            [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                            styleClass="calendar-form-field" [motionOptions]="{ duration: 0 }">
                          </p-datepicker>
                          <span [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                        <ng-container>
                          <p-select styleClass ="cais-fdid-form-dropdown" appendTo="body" [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'" 
                            [options]="viewRow.dropdownvalue" [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]" [showClear]="true" [disabled]="viewRow.isDisable" 
                            [placeholder]="'Enter Value'" class="maxChoiceWidth" [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                          </p-select>
                          <span [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                        <ng-container>
                          <p-multiSelect id ="fdidScreenMultiselect" appendTo="body" [name]="viewRow.field_Name +'array'" [id]="viewRow.field_Name+'array'" 
                            [options]="viewRow.dropdownvalue" [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]" [disabled]="viewRow.isDisable" 
                            [placeholder]="'Please select choices'" class="maxMultiChoiceWidth cais-fdid-multiselect-dropdown cais-fdid-multiselect" [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                          </p-multiSelect>
                          <span [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? FDIDScreenDataDetails['errorFields'][viewRow.field_Name] : '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.dropdown | lowercase) === 'no' && (viewRow?.datatype) !== 'Date' && !viewRow.isDisable && !editDisabledFields.includes(viewRow.ui_Field_Name)){
                        <span>
                          <a aria-label="Clear Value"> <i pTooltip="Clear Value" (click)="FDIDScreenDataDetails[viewRow.field_Name]=null"
                              tooltipPosition="right" class="fa fa-times times-icon" [ngClass]="(FDIDScreenDataDetails.errorFields && FDIDScreenDataDetails['errorFields'][viewRow.field_Name]) ? 'crossIcon' : ''" aria-hidden="true"></i></a>
                        </span>
                        }
                      </span>
                    </div>
                  </div>
                </span>
              </span>
            }
          }
          <!-- End of Medium Scaled Field -->
        </div>
        }
      <!-- End of Record Details -->
      <mat-divider></mat-divider>

      <!-- LTID Details -->
      @if(caisServiceService.hasAnyActiveField(LTIDGridColumns)) {
        <mat-list-item class="list-item-title">LTID Details</mat-list-item>
        <div class="ui-grid-col-12 container">
          <p-table id="EditLTIDTable" [columns]="LTIDGridColumns" [value]="LTIDDataSet" class="LTIDDTTable">
            <ng-template pTemplate="header" let-columns let-rowIndex=rowIndex>
              <tr>
                <th id="header"></th>
                @for(col of columns; track col.header + '-'+ $index) {
                <th id="ui_columnname" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                  {{col.ui_columnname}}
                </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
              <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
                @if((LTIDDataSet.length === (rowIndex+1))){
                <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="LTIDDataSet.push({largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: ''});"><em class="pi pi-plus"></em></a></td>
                }
                @if((LTIDDataSet.length !== (rowIndex+1))){
                <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="removeLTID(rowIndex)"><em class="pi pi-minus"></em></a></td>
                }
                @for(col of columns; track col.datatype + '-'+ $index) {
                <td pEditableColumn class="ui-resizable-column" [ngClass]="{'notdisplay':((col?.display | lowercase) == 'false'), 'errorFieldBorderBottom':(row['errorFields'] && row['errorFields'][col.mappingkey])}">
                  <p-cellEditor>
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no'){
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [id]="row[col.mappingkey]+'string'" [(ngModel)]="row[col.mappingkey]" [placeholder]="(col.placeholder ? col.placeholder : '')"
                        [disabled]="col.disabled" [title]="(col.placeholder ? col.placeholder : '')">
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'date'){
                    <ng-template pTemplate="input">
                        <p-datepicker inputId="dplt" [touchUI]="true" [(ngModel)]="row[col.mappingkey]" dateFormat="yy-mm-dd" [placeholder]="(col.placeholder ? col.placeholder : '')" 
                          appendTo="body" [disabled]="col.disabled" [readonlyInput]="false"
                          styleClass="calendar-form-field" [motionOptions]="{ duration: 0 }">
                        </p-datepicker>
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){
                    <ng-template pTemplate="input">
                      <p-select styleClass ="cais-fdid-form-dropdown" appendTo="body" [name]="row[col.mappingkey]+'singleselect'" [id]="row[col.mappingkey]+'singleselect'" 
                        [options]="col.dropdownvalue" [(ngModel)]="row[col.mappingkey]" [disabled]="col.disabled" [showClear]="true" 
                        [placeholder]="'Enter Value'" class="maxChoiceWidth">
                      </p-select>
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no'){
                    <ng-template pTemplate="output">
                        {{row[col.mappingkey]}}
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'date'){
                    <ng-template pTemplate="output">
                      {{row[col.mappingkey]}}
                    </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){
                    <ng-template pTemplate="output">
                      {{row[col.mappingkey]}}
                    </ng-template>
                    }
                  </p-cellEditor>
                </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      <!-- End of LTID Details -->
      <div class="ui-grid-col-12 container">&nbsp;</div>
      <!-- Address Details -->
      <mat-divider></mat-divider>
      @if(caisServiceService.hasAnyActiveField(addressColumns)) {
      <mat-list-item class="list-item-title">Address Details</mat-list-item>
        <div class="ui-grid-col-12 container">
          <p-table id="EditFDIDAddressTable" [columns]="addressColumns" [value]="FDIDAddressDetails" class="AddressTable" [resizableColumns]="true" #edit_dt>
            <ng-template pTemplate="colgroup" let-columns>
              <colgroup>
                @for(col of columns; track col.header + '-'+ $index) {
                  <col style="min-width: 120px;">
                }
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns let-ri=rowIndex>
              <tr>
                <th id="header"></th>
                @for(col of columns; track col.header + '-'+ $index) {
                <th id="colHeader">
                  {{col.header}}
                </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-columns="columns" let-addressRowData let-rowIndex="rowIndex">
              <tr [pSelectableRowIndex]="rowIndex" [pSelectableRow]="addressRowData" class="ui-widget-NoUpdated-row">
                @if((FDIDAddressDetails.length === (rowIndex+1))){
                  <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="FDIDAddressDetails.push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em class="pi pi-plus"></em></a></td>
                  }
                  @if((FDIDAddressDetails.length !== (rowIndex+1))){
                  <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="FDIDAddressDetails.splice((rowIndex+1),1);"><em class="pi pi-minus"></em></a></td>
                  }
                @for(col of columns; track col.header + '-'+ $index) {
                <td pEditableColumn class="ui-resizable-column" [ngClass]="{'errorFieldBorderBottom':(addressRowData['errorFields'] && addressRowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                  @if(col.field === 'Action' && !Edit && !View){
                  <span>
                    <p-button class="pi pi-xxx" class="fa fa-xxx iconBtn" 
                    matTooltip="Copy Address" id="{{rowIndex}}"
                    matTooltipPosition="above"
                     appendTo="body" icon="fa fa-fw fa-copy" 
                     (click)="copyAddress(FDIDAddressDetails[rowIndex],rowIndex,true,rowIndex)"></p-button>
                  </span>     
                  }             
                  @if(!['Action','addr_regionCode', 'addr_countryCode'].includes(col.field)){
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [id]="addressRowData[col.field]+'string'" [(ngModel)]="addressRowData[col.field]" [maxlength]="col.maxlength" [disabled]="col.disabled">
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{addressRowData[col.field]}}
                    </ng-template>
                  </p-cellEditor>
                  }
                  <!-- Country & Region Code Menu List -->
                  @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                  <p-select styleClass ="cais-fdid-form-dropdown justify-center table-column-dropdown" [id]="addressRowData[col.field]+'singleselect'" 
                    appendTo="body" [options]="col.dropdownvalue" [(ngModel)]="addressRowData[col.field]" [showClear]="true" [filter]="true" [disabled]="col.disabled" 
                    [placeholder]="'Enter Value'" class="maxChoiceWidth" (ngModelChange)="addressRowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && addressRowData['addr_regionCode'] && (!addressRowData['addr_countryCode'] || ['US', 'CA'].includes(addressRowData['addr_countryCode']))) ? addressRowData['addr_regionCode'].slice(0,2) : addressRowData['addr_countryCode'])">
                  </p-select>
                  }
                </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      <!-- End of Address Details -->
      <mat-divider></mat-divider>
      <mat-list-item class="list-item-title">Natural Person/Legal Entity List Details</mat-list-item>

      <!-- TID Generator Button -->
        <div class="ui-grid-col-12 container text-right nopadding">
          <div class="col-lg-12">
            <label class="nopadding" for="addCustomerSearchDialogBtn">
              <button  pButton id="addCustomerSearchDialogBtn" type="button" [disabled]="false" class="button customer-search-button btn-lg" title="Search Customer" (click)="caisServiceService.isDisplayCustomerSearchList = true;" icon="pi pi-search"></button>
            </label>
            <label class="nopadding" for="TIDCorrectionBtn">
              <button pButton id="TIDCorrectionBtn" type="button" [ngClass]="isClickOnTIDCorrection ? 'activeTIDCorrectionBtn': ''" [disabled]="false" label="TID Correction"  class="button form-action-button btn-lg form-action-button-label" (click)="TIDCorrectionConfirmation();"></button>
            </label>
            <label class="nopadding" for="TIDUpdateDialogBtn">
              <button pButton id="TIDUpdateDialogBtn" type="button" [disabled]="((selectedTabIndex===0 || selectedTabIndex===NaturalPersons.length || TIDUpdatedTabIndexes.includes(selectedTabIndex))?true:false)" label="TID Update" (click)="openTIDUpdate();" class="button form-action-button btn-lg form-action-button-label"></button>
            </label>
            <label class="nopadding" for="TIDGeneratorDialogBtn">
              <button pButton id="TIDGeneratorDialogBtn" type="button" [disabled]="false" label="TID Generator" (click)="openTIDGenrator()" class="button form-action-button btn-lg form-action-button-label"></button>
            </label>
            <label class="nopadding" for="AddEditNaturalPersonTabBtn">
              <button pButton id="AddEditNaturalPersonTabBtn" type="button" [disabled]="false" label="Add Natural Person" (click)="addNewTab('Natural Person');" class="button form-action-button btn-lg form-action-button-label"></button>
            </label>
            <label class="nopadding" for="AddEditLegalEntityTabBtn">
              <button pButton id="AddEditLegalEntityTabBtn" type="button" [disabled]="false" label="Add Legal Entity" (click)="addNewTab('Legal Entity');" class="button form-action-button btn-lg form-action-button-label"></button>
            </label>
          </div>
        </div>
      <!-- End of TID Generator Button -->
      <!-- Natural Person/Legal Entity List -->
        <div class="ui-grid-col-12 container">
        <p-tabs [id]="'editNaturalPersonLegalEntityTab'" [value]="selectedTabIndex" class="cais-fdid-tab" (valueChange)="handleChange($event)"  scrollable>
          <p-tablist>
            @for(NaturalPerson of NaturalPersons; track NaturalPerson.tabIndex + '-'+ $index; let i = $index){
            <p-tab [value]="NaturalPerson.tabIndex"
              [ngClass]="NaturalPersonDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[0] ? 'preTIDUpdateHeader' : (NaturalPersonDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[1] ? 'postTIDUpdateHeader' : '')"
              [style]="{'border':NaturalPersonDataDetails[i] && NaturalPersonDataDetails[i].errorFields ? '2px groove red' : 'none', 'display': NaturalPerson.id===0 && selectedTabIndex!==NaturalPerson.tabIndex && NaturalPersonDataDetails[0] && !NaturalPersonDataDetails[0].errorFields ? 'none' : 'block'}">
              {{NaturalPerson.name}}
            </p-tab>
            }
            @for (LegalEntity of LegalEntities; track LegalEntity.tabIndex + '-'+ $index;let i = $index){
            <p-tab [value]="LegalEntity.tabIndex"
              [ngClass]="isClickOnTIDCorrection ? '' : LegalEntityDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[0] ? 'preTIDUpdateHeader' : (LegalEntityDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[1] ? 'postTIDUpdateHeader' : '')"
              [style]="{'border':LegalEntityDataDetails[i] && LegalEntityDataDetails[i].errorFields ? '2px groove red' : 'none', 'display': LegalEntity.id===0 && selectedTabIndex!==LegalEntity.tabIndex && LegalEntityDataDetails[0] && !LegalEntityDataDetails[0].errorFields ? 'none' : 'block'}">
              {{LegalEntity.name}}
            </p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            @for(NaturalPerson of NaturalPersons; track NaturalPerson.tabIndex + '-'+ $index; let i = $index){
            <ng-container>
              <p-tabpanel [value]="NaturalPerson.tabIndex">
                @if(Edit && NaturalPersonDataDetails.length > 0){
                <div class="ui-grid-col-12 container contents">
                  <!-- Natural Person Fields -->
                  @for(viewRow of NaturalPersonScreenDataDetails; track viewRow.ui_Field_Name + '-'+ $index) {
                    @if(!viewRow.isOptionalFields){
                      <!-- Generate Encrypted TID Value -->
                        @if(viewRow.ui_Field_Name==='TID Value'){
                          <app-tid-generator [GeneratorType]="'formTIDGenerator'" [UserType]="'NaturalPerson'" [TIDType]="NaturalPersonDataDetails[i].tidType" [foreignTIDType]="NaturalPersonDataDetails[i].foreignTIDType" (receiveTIDValue)="applyTIDValue('NaturalPerson', i);"></app-tid-generator>
                        }
                      <!-- End of Generating Encrypted TID Value -->
                      <span
                        [ngClass]="((editScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || CommonNegotiatedFields.includes(viewRow.ui_Field_Name)) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
                        <span>
                          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                            <div
                              [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                              <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                              @if(viewRow.isrequired){
                              <strong class="error-mark">*</strong>
                              }
                            </div>
                            <!-- Switch for preserving Important Field value -->
                            @if(!['Add Natural Person'].includes(NaturalPerson.name) &&
                            editDisabledFields.includes(viewRow.ui_Field_Name)){
                            <div [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
                              <span>
                                <ng-container>
                                  @if(isClickOnTIDCorrection){
                                  <p-toggleswitch [(ngModel)]="isClickOnTIDCorrection"></p-toggleswitch>
                                  }
                                  @else{
                                  <p-toggleswitch (onChange)="NPTIDSwitches[i] = !$event.checked;"></p-toggleswitch>
                                  }
                                </ng-container>
                              </span>
                            </div>
                            }
                            <!-- End of Switch for preserving Important Field value -->
                            <div
                              [ngClass]="(viewRow.isLargeField ? (!['Add Natural Person'].includes(NaturalPerson.name) && editDisabledFields.includes(viewRow.ui_Field_Name) ? 'ui-g-12 ui-md-7 ui-lg-7 quick-view-grid-row-hg' : 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg') : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                              @if(!yearField.includes(viewRow.ui_Field_Name)){
                              <span>
                                @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                                <ng-container>
                                  <input pInputText [id]="viewRow.field_Name+'string'"
                                    [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]"
                                    [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true :(['Add Natural Person'].includes(NaturalPerson.name) && editDisabledFields.includes(viewRow.ui_Field_Name) ? false : (editDisabledFields.includes(viewRow.ui_Field_Name) && NPTIDSwitches[i]===false ? NPTIDSwitches[i] : viewRow.isDisable))"
                                    [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')"
                                    [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off"
                                    [maxlength]="viewRow.maximumLength"
                                    [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorField' : ''" />
                                  <span
                                    [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields
                                    && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                                    NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                                </ng-container>
                                }
                                @if((viewRow?.datatype | lowercase) === 'date'){
                                <ng-container>
                                  <p-datepicker inputId="dnp" [touchUI]="true"
                                    [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]" dateFormat="yy-mm-dd"
                                    [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" showButtonBar="true"
                                    appendTo="body"
                                    [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true :viewRow.isDisable"
                                    [readonlyInput]="false"
                                    [maxDate]="FutureRestrictedFields.includes(viewRow.ui_Field_Name) ? maximumDateTime : ''"
                                    [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                                    styleClass="calendar-form-field" [motionOptions]="{ duration: 0 }">
                                  </p-datepicker>
                                  <span
                                    [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields
                                    && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                                    NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                                </ng-container>
                                }
                                @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' &&
                                (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                                <ng-container>
                                  <p-select styleClass="cais-fdid-form-dropdown" appendTo="body"
                                    [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'"
                                    [options]="viewRow.dropdownvalue" [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]"
                                    [showClear]="true"
                                    [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true :caisServiceService.isDisabled(viewRow, NaturalPersonDataDetails[i])"
                                    (onChange)="caisServiceService.onChangeSelectionBox(viewRow, NaturalPersonDataDetails[i])"
                                    [placeholder]="'Enter Value'" class="maxChoiceWidth"
                                    [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                                  </p-select>
                                  <span
                                    [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields
                                    && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                                    NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                                </ng-container>
                                }
                                @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' &&
                                (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                                <ng-container>
                                  <p-multiSelect id="editNpCustTypeMultiselect" appendTo="body" [name]="viewRow.field_Name +'array'"
                                    [id]="viewRow.field_Name+'array'" [options]="viewRow.dropdownvalue"
                                    [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]"
                                    [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true :viewRow.isDisable"
                                    [placeholder]="'Please select choices'"
                                    class="maxMultiChoiceWidth cais-fdid-multiselect-dropdown cais-fdid-multiselect"
                                    [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                                  </p-multiSelect>
                                  <span
                                    [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields
                                    && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                                    NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                                </ng-container>
                                }
                              </span>
                              }
                              @if(yearField.includes(viewRow.ui_Field_Name)){
                              <span>
                                <input pInputText inputId="birthYear" class="birthYear" [id]="viewRow.field_Name+i" [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]" [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true :viewRow.isDisable"
                                  autocomplete="off" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [maxlength]="viewRow.maximumLength" [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorField' : ''"
                                  (keyup)="maskYear()" (focus)="unMaskYear(viewRow.value)" (focusout)="maskYear()" />
                                <span [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                              </span>
                              }
                              @if((viewRow?.dropdown | lowercase) === 'no' && (viewRow?.datatype) !== 'Date' && !viewRow.isDisable && !editDisabledFields.includes(viewRow.ui_Field_Name)){
                              <span>
                                <a aria-label="Clear Value"> <i pTooltip="Clear Value" (click)="NaturalPersonDataDetails[i][viewRow.field_Name]=null" tooltipPosition="right"
                                    class="fa fa-times times-icon" aria-hidden="true" [ngClass]="(NaturalPersonDataDetails[i].errorFields && NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'crossIcon' : ''"></i></a>
                              </span>
                              }
                            </div>
                          </div>
                        </span>
                      </span>
                      <!-- Instructions for TID Value Generation -->
                        @if(viewRow.ui_Field_Name==='TID Value'){
                          <app-tid-generator [GeneratorType]="'TIDGeneratorInstructions'"></app-tid-generator>
                        }
                      <!-- End of Instructions for TID Value Generation -->
                    }
                  }
                  <!-- End of Natural Person Fields -->
                </div>
                }
                <!-- Add Natural Person Address Details -->
                @if(caisServiceService.hasAnyActiveField(addressColumns)) {
                  <div class="ui-grid-col-12 container contents">
                    <p-table id="EditNaturalPersonAddressTable" [columns]="addressColumns"
                      [value]="NaturalPersonAddressDetails[i]" class="AddressTable form-table" [resizableColumns]="true" #edit_dt>
                      <ng-template pTemplate="colgroup" let-columns>
                        <colgroup>
                          @for(col of columns; track col.header + '-'+ $index) {
                          <col style="min-width: 120px;">
                          }
                        </colgroup>
                      </ng-template>
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th id="header"></th>
                          <th id="Action">Action</th>
                          @for(col of columns; track col.header + '-'+ $index) {
                          <th id="colHeader">
                            {{col.header}}
                          </th>
                          }
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
                        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri">
                          @if((NaturalPersonAddressDetails[i].length === (ri+1))){
                          <td class="text-center"><a [ngClass]="{'disabledLink': true}" 
                              (click)="NaturalPersonAddressDetails[i].push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em
                                class="pi pi-plus"></em></a></td>
                          }
                          @if((NaturalPersonAddressDetails[i].length !== (ri+1))){
                          <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="NaturalPersonAddressDetails[i].splice(ri+1,1);"><em
                                class="pi pi-minus"></em></a></td>
                          }
                          <td>
                            @if(Edit && !View){
                            <span>
                              <p-button class="pi pi-xxx" class="fa fa-xxx iconBtn" matTooltip="Copy Address" id="{{ri}}"
                                matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-copy"
                                (click)="copyAddress(FDIDAddressDetails[ri],ri,true,i)"></p-button>
                            </span>
                            }
                          </td>
                          @for(col of columns; track col.header + '-'+ $index) {
                          <td pEditableColumn
                            [ngClass]="{'errorFieldBorderBottom':(rowData['errorFields'] && rowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                            @if(!['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                            <p-cellEditor>
                              <ng-template pTemplate="input">
                                <input pInputText type="text" [id]="rowData[col.field]+'string'" [(ngModel)]="rowData[col.field]"
                                  [disabled]="col.disabled" [maxlength]="col.maxlength">
                              </ng-template>
                              <ng-template pTemplate="output">
                                {{rowData[col.field]}}
                              </ng-template>
                            </p-cellEditor>
                            }
                            <!-- Country & Region Code Menu List -->
                            @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                            <p-select styleClass="cais-fdid-form-dropdown justify-center table-column-dropdown"
                              [id]="rowData[col.field]+'singleselect'" appendTo="body" [options]="col.dropdownvalue"
                              [(ngModel)]="rowData[col.field]" [showClear]="true" [filter]="true" [placeholder]="'Enter Value'"
                              class="maxChoiceWidth" [disabled]="col.disabled" 
                              (ngModelChange)="rowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && rowData['addr_regionCode'] && (!rowData['addr_countryCode'] || ['US', 'CA'].includes(rowData['addr_countryCode']))) ? rowData['addr_regionCode'].slice(0,2) : rowData['addr_countryCode'])">
                            </p-select>
                            }
                          </td>
                          }
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                }
                <!-- End of Add Natural Person Address Details -->
                <!-- Add/Save Natural Person -->
                <div class="ui-dialog-buttonpane ui-helper-clearfix pull-right">
                  <p-button type="button" icon="fa fa-close" id="ResetNaturalPerson" (click)="resetNaturalPerson(i);"
                    class="cais-fdid-footer-button" label="Reset"
                    [disabled]="caisServiceService.TIDUpdateStatuses.includes(NaturalPersonDataDetails[i]?.tidUpdate)"></p-button>
                  <p-button type="button" icon="fa fa-check" id="SaveNaturalPerson" (click)="saveNaturalPerson(i);"
                    class="cais-fdid-footer-button" label="Save Natural Person"></p-button>
                  <p-button type="button" icon="fa fa-trash" id="RemoveNaturalPerson" (click)="removeNaturalPerson(i);"
                    class="cais-fdid-footer-button" label="Remove"
                    [disabled]="(NaturalPerson.id===0) || (NaturalPersonDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[0])"></p-button>
                </div>
                <!-- End of Add/Save Natural Person -->
              </p-tabpanel>
            </ng-container>
            }
            @for(LegalEntity of LegalEntities; track LegalEntity.tabIndex + '-'+ $index; let i = $index) {
            <ng-container>
               <p-tabpanel [value]="LegalEntity.tabIndex">
                 @if(Edit && LegalEntityDataDetails.length > 0){
                <div class="ui-grid-col-12 container contents">
                  <!-- Legal Entity Fields -->
                  @for(viewRow of LegalEntityScreenDataDetails; track viewRow.ui_Field_Name + '-'+ $index) {
                    @if(!viewRow.isOptionalFields){
                      <!-- Generate Encrypted TID Value -->
                        @if(viewRow.ui_Field_Name==='TID Value'){
                          <app-tid-generator [GeneratorType]="'formTIDGenerator'" [UserType]="'LegalEntity'" [TIDType]="LegalEntityDataDetails[i].tidType" [foreignTIDType]="LegalEntityDataDetails[i].foreignTIDType" (receiveTIDValue)="applyTIDValue('LegalEntity', i);"></app-tid-generator>
                        }
                      <!-- End of Generating Encrypted TID Value -->
                      <span [ngClass]="((editScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || CommonNegotiatedFields.includes(viewRow.ui_Field_Name)) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
                        <span>
                          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                            <div [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                              <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                              @if(viewRow.isrequired){
                              <strong class="error-mark">*</strong>
                              }
                            </div>
                            <!-- Switch for preserving Important Field value -->
                            @if(!['Add Legal Entity'].includes(LegalEntity.name) && editDisabledFields.includes(viewRow.ui_Field_Name)){
                              <div [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
                                <span>
                                  <ng-container>
                                    @if(isClickOnTIDCorrection){
                                    <p-toggleswitch [(ngModel)]="isClickOnTIDCorrection"></p-toggleswitch>
                                    }
                                    @else{
                                      <p-toggleswitch (onChange)="LETIDSwitches[i] = !$event.checked;"></p-toggleswitch>
                                    }
                                  </ng-container>
                                </span>
                              </div>
                              }
                            <!-- End of Switch for preserving Important Field value -->
                            <div [ngClass]="(viewRow.isLargeField ? (!['Add Legal Entity'].includes(LegalEntity.name) && editDisabledFields.includes(viewRow.ui_Field_Name) ? 'ui-g-12 ui-md-7 ui-lg-7 quick-view-grid-row-hg' : 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg') : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                              @if(!yearField.includes(viewRow.ui_Field_Name)){
                              <span>
                                @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                                <ng-container>
                                  <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]" [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : (['Add Legal Entity'].includes(LegalEntity.name) && editDisabledFields.includes(viewRow.ui_Field_Name) ? false : (editDisabledFields.includes(viewRow.ui_Field_Name) && LETIDSwitches[i]===false ? LETIDSwitches[i] : viewRow.isDisable))" 
                                  [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off" 
                                  [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorField' : ''" 
                                  (keyup)="setTIDType(viewRow.field_Name, i)" (ngModelChange)="AutoGenerateTID($event, viewRow.field_Name, i)" />
                                  <span [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                                </ng-container>
                                }
                                @if((viewRow?.datatype | lowercase) === 'date'){
                                <ng-container>
                                  <p-datepicker inputId="dle" [touchUI]="true" [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]" dateFormat="yy-mm-dd" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                                    showButtonBar="true" appendTo="body" [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : viewRow.isDisable" [readonlyInput]="false" [maxDate]="FutureRestrictedFields.includes(viewRow.ui_Field_Name) ? maximumDateTime : ''" 
                                    [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                                    styleClass="calendar-form-field" [motionOptions]="{ duration: 0 }">
                                  </p-datepicker>
                                  <span [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                                </ng-container>
                                }
                                @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                                <ng-container>
                                  <p-select styleClass ="cais-fdid-form-dropdown" appendTo="body" [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'" 
                                    [options]="viewRow.dropdownvalue" [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]" [showClear]="true" [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : caisServiceService.isDisabled(viewRow, LegalEntityDataDetails[i])" (onChange)="caisServiceService.onChangeSelectionBox(viewRow, LegalEntityDataDetails[i])" 
                                    [placeholder]="'Enter Value'" class="maxChoiceWidth" [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''"
                                    (ngModelChange)="AutoGenerateTID($event, viewRow.field_Name, i)">
                                  </p-select>
                                  <span [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                                </ng-container>
                                }
                                @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                                <ng-container>
                                  <p-multiSelect id = "editLgCustTypeMultiselect" appendTo="body" [name]="viewRow.field_Name +'array'" [id]="viewRow.field_Name+'array'" 
                                    [options]="viewRow.dropdownvalue" [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]" [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : viewRow.isDisable" 
                                  placeholder="'Please select choices'" class="maxMultiChoiceWidth cais-fdid-multiselect-dropdown cais-fdid-multiselect" [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                                  </p-multiSelect>
                                  <span [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] : '')}}</span>
                                </ng-container>
                                }
                              </span>
                              }
                              @if((viewRow?.dropdown | lowercase) === 'no' && (viewRow?.datatype) !== 'Date' && !viewRow.isDisable && !editDisabledFields.includes(viewRow.ui_Field_Name)){
                              <span>
                                <a aria-label="Clear Value"> <i pTooltip="Clear Value" (click)="LegalEntityDataDetails[i][viewRow.field_Name]=null"
                                    tooltipPosition="right" class="fa fa-times times-icon" aria-hidden="true" [ngClass]="(LegalEntityDataDetails[i].errorFields && LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'crossIcon' : ''"></i></a>
                              </span>
                              }
                            </div>
                          </div>
                        </span>
                      </span>
                      <!-- Instructions for TID Value Generation -->
                        @if(viewRow.ui_Field_Name==='TID Value'){
                          <app-tid-generator [GeneratorType]="'TIDGeneratorInstructions'"></app-tid-generator>
                        }
                      <!-- End of Instructions for TID Value Generation -->
                    }
                  }
                  <!-- End of Legal Entity Fields -->
                </div>
                }
                <!-- Add Legal Entity Address Details -->
                @if(caisServiceService.hasAnyActiveField(addressColumns)) {
                  <div class="ui-grid-col-12 container contents">
                    <p-table id="EditLegalEntityAddressTable" [columns]="addressColumns" [value]="LegalEntityAddressDetails[i]" class="AddressTable form-table" [resizableColumns]="true" #edit_dt>
                      <ng-template pTemplate="colgroup" let-columns>
                        <colgroup>
                          @for(col of columns; track col.header + '-'+ $index) {
                            <col style="min-width: 120px;">
                          }
                        </colgroup>
                      </ng-template>
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th id="header"></th>
                          <th id="Action">Action</th>
                          @for(col of columns; track col.header + '-'+ $index) {
                          <th id="colHeader">
                            {{col.header}}
                          </th>
                        }
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
                        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri">
                          @if((LegalEntityAddressDetails[i].length === (ri+1))){
                            <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="LegalEntityAddressDetails[i].push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em class="pi pi-plus"></em></a></td>
                            }
                            @if((LegalEntityAddressDetails[i].length !== (ri+1))){
                            <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="LegalEntityAddressDetails[i].splice(ri+1,1);"><em class="pi pi-minus"></em></a></td>
                            }
                          <td>
                            @if(Edit && !View){
                              <span>
                                <p-button class="pi pi-xxx" class="fa fa-xxx iconBtn" 
                                matTooltip="Copy Address" id="{{ri}}"
                                matTooltipPosition="above"
                                 appendTo="body" icon="fa fa-fw fa-copy" 
                                 (click)="copyAddress(FDIDAddressDetails[ri],ri,false,i)"></p-button>
                              </span>     
                              }             
                          </td>
                          @for(col of columns; track col.field + '-'+ $index) {
                          <td pEditableColumn [ngClass]="{'errorFieldBorderBottom':(rowData['errorFields'] && rowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                            @if(!['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                            <p-cellEditor>
                              <ng-template pTemplate="input">
                                  <input pInputText type="text" [id]="rowData[col.field]+'string'" [(ngModel)]="rowData[col.field]" [maxlength]="col.maxlength" [disabled]="col.disabled">
                              </ng-template>
                              <ng-template pTemplate="output">
                                  {{rowData[col.field]}}
                              </ng-template>
                            </p-cellEditor>
                            }
                            <!-- Country & Region Code Menu List -->
                            @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                            <p-select styleClass ="cais-fdid-form-dropdown justify-center table-column-dropdown" [id]="rowData[col.field]+'singleselect'"
                              appendTo="body" [options]="col.dropdownvalue" [(ngModel)]="rowData[col.field]" [showClear]="true" [filter]="true" [disabled]="col.disabled" 
                              [placeholder]="'Enter Value'" class="maxChoiceWidth" (ngModelChange)="rowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && rowData['addr_regionCode'] && (!rowData['addr_countryCode'] || ['US', 'CA'].includes(rowData['addr_countryCode']))) ? rowData['addr_regionCode'].slice(0,2) : rowData['addr_countryCode'])">
                            </p-select>
                            }
                          </td>
                          }
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                }
                <!-- End of Add Legal Entity Address Details -->
                <!-- Add/Save Legal Entity -->
                  <div class="ui-dialog-buttonpane ui-helper-clearfix pull-right">
                    <p-button type="button" icon="fa fa-close" id="ResetLegalEntity" (click)="resetLegalEntity(i);" class="cais-fdid-footer-button" label="Reset" [disabled]="caisServiceService.TIDUpdateStatuses.includes(LegalEntityDataDetails[i]?.tidUpdate)"></p-button>
                    <p-button type="button" icon="fa fa-check" id="SaveLegalEntity" (click)="saveLegalEntity(i);" class="cais-fdid-footer-button" label="Save Legal Entity"></p-button>
                    <p-button type="button" icon="fa fa-trash" id="RemoveLegalEntity" (click)="removeLegalEntity(i);" class="cais-fdid-footer-button" label="Remove" [disabled]="(LegalEntity.id===0) || (LegalEntityDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[0])"></p-button>
                  </div>
                <!-- End of Add/Save Legal Entity -->
               </p-tabpanel>
              </ng-container>
            }
          </p-tabpanels>
      </p-tabs>
        </div>
      <!-- End of Natural Person/Legal Entity List -->
    </div>
    <ng-template #footer>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <p-button type="button" class="cais-fdid-footer-button" icon="fa fa-close" id="CloseEditDialog" (click)="Edit=false;isClickedOnce=false;closeDialog(false);" label="Close">
        </p-button>
        <p-button type="button" class="cais-fdid-footer-button" icon="fa fa-check" id="editSaveDialog" (click)="editFDIDRecord();" [disabled]="isClickedOnce" label="Save">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
<!-- End of Editing Panel Code -->

<!-- Confirmation Dialog-Box -->
  <p-confirmDialog  
    acceptLabel="Ok" 
    key="informationDialoge" 
    [rejectVisible]="true" 
    appendTo="body" 
    header="Information" 
    icon="pi pi-exclamation-triangle" 
    [baseZIndex]="999999"
    styleClass="confirm-dialog">
  </p-confirmDialog>
  <p-confirmDialog 
   id="cais-correction-confirm-dialog"
   styleClass="confirm-dialog"
   key="confirmationDialog" 
   appendTo="body" header="Confirmation"
   icon="pi pi-exclamation-triangle"
   [baseZIndex]="999999">
  </p-confirmDialog>

@if(caisExceptionServiceService.isCaisView){
<app-view
 [rowDataforDialog] ="rowDataforDialog"
 [screenType]="screenType"
 [activeRecordType]="activeRecordType" 
 [showRecordDetails]="false"></app-view>
}

<!-- TID Generator -->
<app-tid-generator></app-tid-generator>

<!-- CAIS Audit Trail History -->
 @if(isAuditTrail){
<app-cais-audit-trail-dialog 
  id="CAIS-FDID-Audit-Trail" 
  (closeEventDialog)="isAuditTrail = false"
  [SelectedRow]="rowDataforDialog"
  [isAuditTrailOpen]="isAuditTrail"
  [pageName]="ApplicationName">
</app-cais-audit-trail-dialog>
 }

<!-- CAIS Customer Search List -->
<app-cais-customer-search
[customerKeyword]="(selectedTabIndex >= NaturalPersons.length ? LegalEntityDataDetails[0] && '' : NaturalPersonDataDetails[0] && '')"
[selectedCustomerType]="selectedCustomerType" 
(selectConfirmCustomer)="selectedCustomer($event)">
</app-cais-customer-search>